import { Button, Dialog, Icon, Stack, styled, Typography } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { useEffect, useState } from "react"
import { getBundleParams } from "@bundles/settings/utils"
import { useUser } from "@tm/context-distribution"
import { useUserSettingsStore } from "../business"

const HeaderBox = styled(Stack)(() => ({
    backgroundColor: "#000",
    width: "100%",
}))

export function CompleteProfileDialog() {
    const completeProfileDialogShown = sessionStorage.getItem("CompleteProfileDialogShown")
    const isCompleteProfileDialogShown = completeProfileDialogShown !== null && completeProfileDialogShown === "true"
    const [openDialog, setOpenDialog] = useState(true)
    const { translateText } = useLocalization()
    const { showEditProfile } = getBundleParams()
    const { userContext } = useUser()
    const [editProfileModalOpen, setEditProfileModalOpen] = useUserSettingsStore((store) => [
        store.state.editProfileModalOpen,
        store.actions.setEditProfileModalOpen,
    ])

    useEffect(() => {
        if (editProfileModalOpen && !isCompleteProfileDialogShown) {
            setOpenDialog(false)
            sessionStorage.setItem("CompleteProfileDialogShown", "true")
        }
    }, [editProfileModalOpen, isCompleteProfileDialogShown])

    if (isCompleteProfileDialogShown || !showEditProfile || !userContext.parameter.uniqueEmail) {
        return null
    }

    function dismissDialog() {
        setOpenDialog(false)
        sessionStorage.setItem("CompleteProfileDialogShown", "true")
    }

    return (
        <Dialog open={openDialog} PaperProps={{ sx: { "& > div": { padding: 0 } } }}>
            <Stack direction="column" justifyContent="space-around" gap={4}>
                <HeaderBox direction="row" gap={2} p={1.5}>
                    <Icon name="user" color="white" />
                    <Typography variant="h3" color="white">
                        {translateText(14037).toUpperCase()}
                    </Typography>
                </HeaderBox>
                <Stack gap={2} pl={2} pr={2}>
                    <Typography variant="body1">
                        {`${translateText(14040)} `}
                        <Typography component="span" sx={{ fontWeight: 800 }}>
                            {`${translateText(14041)} `}
                        </Typography>
                        {`${translateText(14042)} `}
                        <Typography component="span" sx={{ fontWeight: 800 }}>
                            {`${translateText(3143)}.`}
                        </Typography>
                    </Typography>
                    <Typography variant="body1">{translateText(14039)}</Typography>
                </Stack>
                <Stack direction="row" gap={1} pb={2} pr={2} pl={2}>
                    <Button onClick={() => setEditProfileModalOpen(true, true)}>{translateText(13887)}</Button>
                    <Button onClick={dismissDialog}>{translateText(14038)}</Button>
                </Stack>
            </Stack>
        </Dialog>
    )
}
